export default __webpack_public_path__ + "static/award-2024-II-24aea1ed3a039f52c4cff5d31c0999e7.png";